import React, { useEffect } from "react";
import { useState } from "react";
import { Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
// import Pagination from "../../common/Pagination/Pagination";
import CardItem from "./CardItem";
import "./style.scss";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import AddDesignationModal from "./AddDesignationModal";
import DesignationsService from "../../../../services/HRM/DesignationsService";

const Designations = () => {
	const [data, setData] = useState([]);
	const [addModal, setAddModal] = useState(false);
	const [item, setItem] = useState({});
	const [hasData, setHasData] = useState(1);
	const [search, setSearch] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const Service = new DesignationsService();

	useEffect(() => {
		setLoading(true);
		Service.getList().then((res) => {
			if (res?.status) {
				const response = res?.data?.data?.data;
				if (!!response?.length) {
					setData(response);
					setHasData(1);
				} else {
					setData([]);
					setHasData(0);
				}
				setLoading(false);
			}
		});
	}, [shouldUpdate]);

	return (
		<div className="department">
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div></div>
					<div className="add-department">
						<Button
							variant="primary"
							className="me-2 h-75"
							onClick={() => {
								setItem({});
								setAddModal(true);
							}}>
							<i className="la la-plus mx-1"></i>
							{Translate[lang]?.add} {Translate[lang]?.designation}
						</Button>
					</div>
				</div>
			</div>

			<Card>
				<Card.Body>
					<div className={`${hasData === 0 ? "text-center" : "table-style"} `}>
						{loading && (
							<div style={{ height: "400px" }}>
								<Loader />
							</div>
						)}

						{hasData === 1 && !loading && (
							<Table responsive>
								<thead>
									<tr className="text-center">
										<th>
											<strong>{Translate[lang]?.title}</strong>
										</th>
										<th>
											<strong>{Translate[lang]?.branch}</strong>
										</th>
										<th>
											<strong>{Translate[lang]?.actions}</strong>
										</th>
									</tr>
								</thead>

								<tbody className="table-body">
									{data?.map((item, index) => {
										return (
											<CardItem
												index={index}
												key={index}
												item={item}
												setItem={setItem}
												setAddModal={setAddModal}
												setShouldUpdate={setShouldUpdate}
											/>
										);
									})}
								</tbody>
							</Table>
						)}
						{hasData === 0 && <NoData />}
						{/* <Pagination
							setData={setData}
							service={departmentService}
							shouldUpdate={shouldUpdate}
							setHasData={setHasData}
							setLoading={setLoading}
							search={search}
						/> */}
					</div>
				</Card.Body>
			</Card>

			{addModal && (
				<AddDesignationModal
					item={item}
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
					Service={{}}
				/>
			)}
		</div>
	);
};

export default Designations;
